export const sponsors2026 = [
  {
    name: "LOGE Wolf Creek",
    blurb:
      "15% off your stay before, during, and after the festival — including their RV hookup spots.",
    href: "https://www.logecamps.com/locations/loge-wolf-creek/",
    logo: null,
  },
  {
    name: "Growing Spaces",
    blurb: "Geodome greenhouses for year-round gardening at altitude.",
    href: "https://growingspaces.com",
    logo: "/sponsors/growing-spaces.png",
  },
  {
    name: "RVshare",
    blurb:
      "RV rentals delivered to the festival — drop-off, set-up, and pick-up.",
    href: "https://rvshare.com",
    logo: "/sponsors/rvshare.png",
  },
];
